import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import AppShell from "@/pages/AppShell";
import ComposerPage from "@/pages/ComposerPage";
import InsightsPage from "@/pages/InsightsPage";
import SubscribePage from "@/pages/SubscribePage";
import SettingsPage from "@/pages/SettingsPage";
import TermsPage from "@/pages/TermsPage";
import TermsOfServicePage from "@/pages/TermsOfServicePage";
import PrivacyPromisePage from "@/pages/PrivacyPromisePage";

function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-8 text-ink-mute">…</div>;
  if (!user) return <Navigate to="/auth" replace />;
  return children;
}

function App() {
  return (
    <div className="App min-h-screen bg-canvas">
      <BrowserRouter>
        <AuthProvider>
          <Toaster
            position="bottom-right"
            toastOptions={{
              style: {
                background: "#F9F8F6",
                color: "#2D2B29",
                border: "1px solid #D5CEBF",
                fontFamily: "'Manrope', sans-serif",
              },
            }}
          />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route
              path="/app"
              element={
                <RequireAuth>
                  <AppShell />
                </RequireAuth>
              }
            >
              <Route index element={<ComposerPage />} />
              <Route path="insights" element={<InsightsPage />} />
              <Route path="subscribe" element={<SubscribePage />} />
              <Route path="subscribe/success" element={<SubscribePage />} />
              <Route path="settings" element={<SettingsPage />} />
            </Route>
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/terms-of-service" element={<TermsOfServicePage />} />
            <Route path="/privacy-promise" element={<PrivacyPromisePage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
